import type { Config } from '.';

const stagingConfig: Config = {
  env: 'staging',

  apiServerBase: import.meta.env.VITE_API_SERVER_BASE || 'https://staging-api.civilgrid.com',

  tileServerBase: import.meta.env.VITE_TILE_SERVER_BASE || 'https://staging-tiles.civilgrid.com',

  mapboxToken: import.meta.env.VITE_MAPBOX_TOKEN || 'UNSET',

  geotechStudyCost: 200,

  personaEnvironmentId: 'env_j2iwdf8Fyn9pfRd4jxwQNKtC',

  googleMapsApiToken: 'AIzaSyC7mEaLivQzB5WP5aNTNcetOCk6GqctXLk',

  esriToken: 'AAPKfd40b74df62f45d4ba5ec3bf97b8a965L2M83hgVWFArUX-pwAmRSL_dOWfMyXud5wSX7OIS9P3WFk7xBZpOMiCONwHPZQ0y',

  posthogApiKey: import.meta.env.VITE_POSTHOG_API_KEY || 'phc_biurTJNCS7qiB5495134BGrsPh92CRG0Ge2gCbZsSlo',
  posthogApiHost: 'https://staging-e.civilgrid.com',
  posthogUiHost: 'https://us.posthog.com',

  knockWebChannelId: '588aa2d3-95b6-4c3d-87ee-9d23bde782b7',

  knockPublicKey: 'pk_lNkfJDnFbAZJt8wB9VqztdBAVET3xPwcEs4qJd2EoU8',
  bugsnagApiKey: '9f8091c7c95f90a9b5cd2da11b96f16c',

  previewEnv: import.meta.env.VITE_PREVIEW_ENV || undefined,
};

export default stagingConfig;
